import { Controller, FieldValues } from 'react-hook-form'
import { RhfProps } from './rhf.props'
import { AutocompleteField, AutocompleteFieldProps } from '../autocomplete-field'

export type AutocompleteFieldRhfProps<T extends FieldValues> = RhfProps<T> &
  AutocompleteFieldProps & {
    matchId?: boolean
  }

export function AutocompleteFieldRhf<T extends FieldValues = FieldValues>({
  name,
  rules,
  control,
  defaultValue,
  matchId,
  options,
  multiple,
  placeholderSearch,
  ...inputProps
}: AutocompleteFieldRhfProps<T>) {
  return (
    <Controller
      name={name}
      rules={rules}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error, isDirty } }) => {
        let currentValue = multiple ? value || [] : value || null
        if (matchId) {
          // @ts-ignore
          currentValue = multiple
            ? (value || []).map((i: any) => options.find((j) => (j.value || j) === i))
            : options.find((i) => (i.value || i) === value) || null
        }

        return (
          <AutocompleteField
            {...inputProps}
            value={currentValue}
            multiple={multiple}
            options={options}
            error={!!error}
            isDirty={isDirty}
            placeholderSearch={placeholderSearch}
            onChange={(v) => {
              let changedVal = v
              if (matchId) {
                // @ts-ignore
                changedVal = Array.isArray(v) ? v.map((i: any) => i?.value || i) : v?.value || v
              }
              onChange(changedVal)
              if (typeof inputProps.onChange === 'function') {
                inputProps.onChange(v)
              }
            }}
            helperText={error ? error.message : inputProps.helperText}
          />
        )
      }}
    />
  )
}
